// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3uq0s","buttons":"SendReceipts_buttons__1Tywo","email":"SendReceipts_email__3FWxA","bookApptTitle":"SendReceipts_bookApptTitle__1Pio0"};